import { initFlyout } from '../../components/flyoutUnderHeader';

export default () => {
  const sizeChartContainer = document.querySelector('.product-detail__size-chart__pane');

  if (sizeChartContainer && sizeChartContainer.getAttribute('initialized') !== 'true') {
    if (document.querySelector('.product-set-detail .set-items')) {
      const sizeChartContainers = document.querySelectorAll('.product-detail__size-chart__pane');
      sizeChartContainers.forEach((fc) => {
        initFlyout(fc);
        if (fc.getAttribute('initialized') !== 'true') {
          fc.setAttribute('initialized', 'true');
        }
      });
    } else {
      initFlyout(sizeChartContainer);
      if (sizeChartContainer.getAttribute('initialized') !== 'true') {
        sizeChartContainer.setAttribute('initialized', 'true');
      }
    }
  }
};
